import React from "react"

type Props = {
    children: React.ReactNode
    type?: string
}

export const LeftAsideLayout: React.FC<Props> = (props) => <aside className={props.type}>{props.children}</aside>
